export const formatUtcDateTimeString = (
  dateString: string | null | undefined
): string => {
  if (!dateString) {
    return "N/A";
  }
  try {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const day = date.getUTCDate().toString().padStart(2, "0");
    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes} UTC`;
  } catch (error) {
    console.error("Error formatting date string:", dateString, error);
    return "Invalid Date";
  }
};
